
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./MainApp": () => {
return Promise.all(/*  | __federation_expose_MainApp */ [__webpack_require__.e(982), __webpack_require__.e(83), __webpack_require__.e(453), __webpack_require__.e(871), __webpack_require__.e(669)]).then(() => (() => (__webpack_require__(9807))));
},
"./ShellModule": () => {
return __webpack_require__.e(/*  | __federation_expose_ShellModule */ 303).then(() => (() => (__webpack_require__(5990))));
},
"./ShellModuleViewProps": () => {
return __webpack_require__.e(/*  | __federation_expose_ShellModuleViewProps */ 418).then(() => (() => (__webpack_require__(5121))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };